import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/')({
  beforeLoad: async ({ context }) => {
    throw redirect({ to: '/admin/orgs' })
  },
  component: () => null,
}) 

